import noAccount from "assets/noAccount.svg";
import LinkBank from "../link-bank";
import { PlaidLinkOptions } from "react-plaid-link";

type NoAccountProps = {
  openPlaid: () => void;
  setPlaidConfig: React.Dispatch<
    React.SetStateAction<PlaidLinkOptions & { isSuccess?: boolean }>
  >;
  type: "user" | "program" | "group";
  groupId?: string;
};

function NoAccount({
  openPlaid,
  setPlaidConfig,
  type,
  groupId,
}: NoAccountProps) {
  return (
    <div className="flex justify-center">
      <div>
        <img src={noAccount} alt="" />
        <p className="text-center">No linked Account</p>
        <LinkBank
          openPlaid={openPlaid}
          setPlaidConfig={setPlaidConfig}
          type={type}
          labelText={"Link External Bank Account"}
          groupId={groupId}
        />
      </div>
    </div>
  );
}

export default NoAccount;
